import { defineComponent, openBlock, createElementBlock, createElementVNode, createVNode, unref, createTextVNode, toDisplayString } from "vue";
import { IconChat } from "@rei/cedar";
const _hoisted_1 = {
  class: "client-response"
};
const _hoisted_2 = {
  class: "client-response__header",
  "data-ui": "syndication-response-header"
};
const _hoisted_3 = {
  class: "client-response__body"
};
const _hoisted_4 = {
  class: "client-response__body-header",
  "data-ui": "syndication-response-department"
};
const _hoisted_5 = {
  class: "client-response__body-date",
  "data-ui": "syndication-response-date"
};
const _hoisted_6 = {
  class: "client-response__body-response",
  "data-ui": "syndication-response-response"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsSyndicatedResponse",
  props: {
    publishDate: {},
    Department: {},
    Response: {},
    Name: {},
    Date: {},
    SourceClientName: {},
    publishTime: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createVNode(unref(IconChat)), createTextVNode(" Response from " + toDisplayString(_ctx.SourceClientName), 1)]), createElementVNode("div", _hoisted_3, [createElementVNode("div", _hoisted_4, toDisplayString(_ctx.Department), 1), createElementVNode("div", _hoisted_5, toDisplayString(_ctx.publishDate), 1), createElementVNode("p", _hoisted_6, toDisplayString(_ctx.Response), 1)])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsSyndicatedResponse2.mjs.map
